import {
  differenceInYears,
  parseISO,
  isValid,
  getYear,
  addYears,
  subDays,
  format,
  isAfter,
  isBefore,
  startOfDay,
} from "date-fns";

// check if the passed values is a valid date or not
export const isValidDate = (value) => {
  if (!value) return false;
  let date;
  // Reject numeric timestamps explicitly
  if (typeof value === "number") {
    return false;
  }

  // If it's a string
  if (typeof value === "string") {
    // Try parsing as ISO first
    date = parseISO(value);

    // Fallback: try native Date constructor
    if (!isValid(date)) {
      date = new Date(value);
    }
  }
  // If it's already a Date object
  else if (value instanceof Date) {
    date = value;
  } else {
    return false;
  }

  return isValid(date);
};

// formatedd Today Date for Date Picker Input

export const formatedTodayData = () => {
  return format(new Date(), "yyyy-MM-dd");
};

// calculate age based on birth date
export const calculateAge = (birthDate) => {
  if (!birthDate) return null;
  const parsedDate = parseISO(birthDate);
  return differenceInYears(new Date(), parsedDate);
};

// get the year from date
export const getYearFromDate = (date) => {
  if (!date || !isValidDate(date)) return null;
  return getYear(date);
};

// get the current hours and minutes
export const timeNow = () => {
  return format(new Date(), "hh:mm");
};

// format date
export const formatDate = (
  date,
  {
    is12Hours = false,
    is12HoursWithSeconds = false,
    is12HoursAMPM = false,
    is24Hours = false,
    apiFormat = false,
    apiFormatwith12Hours = false,
    apiFormatwith12HoursWithSeconds = false,
    apiFormatwith12HoursAMPM = false,
    apiFormatwith12HoursAMPMWithSeconds = false,
    apiFormatwith24Hours = false,
    apiFormatwith24HoursWithSeconds = false,
    previewFormat = true,
    previewFormatwith12Hours = false,
    previewFormatwith12HoursWithSeconds = false,
    previewFormatwith12HoursAMPM = false,
    previewFormatwith24Hours = false,
  } = {
    previewFormat: true,
  }
) => {
  let desiredFormat = "dd-MM-yyyy";

  if (previewFormat) desiredFormat = "dd-MM-yyyy";
  if (previewFormatwith12Hours) desiredFormat = "dd-MM-yyyy hh:mm";
  if (previewFormatwith12HoursWithSeconds)
    desiredFormat = "dd-MM-yyyy hh:mm:ss";
  if (previewFormatwith12HoursAMPM) desiredFormat = "dd-MM-yyyy hh:mm a";
  if (previewFormatwith24Hours) desiredFormat = "dd-MM-yyyy HH:mm";
  if (apiFormat) desiredFormat = "yyyy-MM-dd";
  if (apiFormatwith12Hours) desiredFormat = "yyyy-MM-dd hh:mm";
  if (apiFormatwith12HoursWithSeconds) desiredFormat = "yyyy-MM-dd hh:mm:ss";
  if (apiFormatwith12HoursAMPM) desiredFormat = "yyyy-MM-dd hh:mm a";
  if (apiFormatwith12HoursAMPMWithSeconds)
    desiredFormat = "yyyy-MM-dd hh:mm:ss a";
  if (apiFormatwith24Hours) desiredFormat = "yyyy-MM-dd HH:mm";
  if (apiFormatwith24HoursWithSeconds) desiredFormat = "yyyy-MM-dd HH:mm:ss";
  if (is12Hours) desiredFormat = "hh:mm";
  if (is12HoursWithSeconds) desiredFormat = "hh:mm:ss";
  if (is12HoursAMPM) desiredFormat = "hh:mm:ss a";
  if (is24Hours) desiredFormat = "HH:mm";

  if (!date || !isValidDate(date)) return "";
  return format(date, desiredFormat);
};

// generate disabled dates for date picker
export const generateDisabledDateForDP = (
  date,
  {
    disableFutureDates,
    disableFutureDatesAndToday,
    disablePastDates,
    disablePastDatesAndToday,
  }
) => {
  const today = new Date();
  const d = date; // normalize to calendar day
  if (disableFutureDates) {
    return isAfter(d, today);
  } else if (disableFutureDatesAndToday) {
    return isAfter(d, subDays(today, 1));
  } else if (disablePastDates) {
    return isBefore(d, subDays(today, 1));
  } else if (disablePastDatesAndToday) {
    return isBefore(d, today);
  } else {
    return isAfter(d, today); // default fallback
  }
};
